<template>
  <div class="row rounded px-3 py-4" :class="panelStyle.bg">
    <div
      class="col-md-3 col-sm-12"
      :class="{
        'col-md-3': isTherapyServiceType,
        'col-md-12': !isTherapyServiceType,
      }"
    >
      <div class="bg-white rounded px-3 py-3" :class="panelStyle.border">
        <div class="d-flex">
          <div class="fa-stack fa-1x shadow rounded">
            <i class="fa-stack-1x font-20" :class="panelStyle.icon" />
          </div>
          <div class="ml-2 mt-n1">
            <div class="color-gray-6 d-block font-14">Servicio:</div>
            <div class="font-16 color-black font-weight-bold mt-n1">
              {{ serviceDisciplineName }}
            </div>
          </div>
        </div>
        <div v-if="isTherapyServiceType || isAssistanceServiceType">
          <hr class="my-2" />
          <div class="p-4 text-center font-italic fa-sm">
            {{ serviceMessage }}
          </div>
        </div>
      </div>
    </div>
    <div v-if="isTherapyServiceType" class="col-md-9 col-sm-12">
      <div class="row mt-n2">
        <div class="col-md-4 mt-3 mt-md-0">
          <label class="data-title mb-0">Frecuencia:</label>
          <validation-provider
            v-if="!isReadOnly"
            v-slot="{ errors }"
            name="frequency"
            rules="required"
          >
            <custom-drop-down
              id="ddlFrequency"
              v-model="model.frequency"
              custom-error-msg="La frecuencia es requerida."
              :disabled="isReadOnly"
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              :options="avaliableFrequencies"
              placeholder="Seleccione"
              @input="$emit('on-change-frequency', $event)"
            />
          </validation-provider>
          <span v-else class="d-block font-16 color-black mb-3">
            {{ frequencyName | empty }}
          </span>
        </div>
        <div class="col-md-4 mt-3 mt-md-0">
          <label class="data-title mb-0">Duración:</label>
          <validation-provider
            v-if="!isReadOnly"
            v-slot="{ errors }"
            name="duration"
            rules="required"
          >
            <custom-drop-down
              id="ddlDuration"
              v-model="model.duration"
              custom-error-msg="La duración es requerida."
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              :options="durations"
              placeholder="Seleccione"
              @input="$emit('on-change-duration', $event)"
            />
          </validation-provider>
          <span v-else class="d-block font-16 color-black mb-3">
            {{ durationName | empty }}
          </span>
        </div>
        <div class="col-md-4 mt-3 mt-md-0">
          <label class="data-title mb-0">Modalidad:</label>
          <validation-provider
            v-if="!isReadOnly"
            v-slot="{ errors }"
            name="modality"
            rules="required"
          >
            <custom-drop-down
              id="ddlModality"
              v-model="model.modality"
              custom-error-msg="La modalidad es requerida."
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              :options="modalities"
              placeholder="Seleccione"
              @input="$emit('on-change-modality', $event)"
            />
          </validation-provider>
          <span v-else class="d-block font-16 color-black mb-3">
            {{ modalityName | empty }}
          </span>
        </div>
        <div class="col-md-4 mt-3 mt-md-0">
          <div v-if="showSubDiscipline" class="mb-1 mt-3">
            <label class="data-title mb-0">Subdisciplina:</label>
            <validation-provider
              v-if="!isReadOnly"
              v-slot="{ errors }"
              name="subDiscipline"
              rules="required"
            >
              <custom-drop-down
                v-model="model.subDiscipline"
                custom-error-msg="La subdisciplina es requerida."
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                :options="subDisciplinesOptions"
                placeholder="Seleccione"
                @input="$emit('on-change-sub-discipline', $event)"
              />
            </validation-provider>
            <span v-else class="d-block font-16 color-black mb-3">
              {{ subDiscipline | empty }}
            </span>
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div :class="showExtendedSchoolYearService ? 'col-md-8' : 'col-md-12'">
          <span class="color-gray-6 d-block font-14">
            Servicio de Terapia Compensadas por la cantidad de:
          </span>
          <span class="font-16 color-black">
            {{ compensatoryServiceCount | empty }}
          </span>
        </div>
        <div v-if="showExtendedSchoolYearService" class="col-md-4">
          <span class="color-gray-6 d-block font-14">
            Año Escolar Extendido:
          </span>
          <check-box
            v-model="model.extendedAcademicYearFlag"
            :disabled="showExtendedSchoolYearService"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//libs components
import { ValidationProvider } from 'vee-validate';
import CustomDropDown from 'custom-drop-down';
import CheckBox from 'CheckBox';
import disciplineTypes from '@/utils/constants/disciplineTypes';
import rpContractAmendmentReasons from '@/utils/constants/rpContractAmendmentReasons.js';
import { getSubDisciplinesRP as _getSubDisciplines } from '@/services/uspqrp/service-cost.api';
import subDisciplineTypes from '@/utils/constants/subDisciplineTypes.js';
import frequencyType from '@/utils/constants/frequencyType.js';

export default {
  name: 'InterventionService',
  components: {
    ValidationProvider,
    CustomDropDown,
    CheckBox,
  },
  watch: {
    serviceInfo: {
      deep: true,
      immediate: true,
      handler(value) {
        if (this.contractId && value) {
          this.model = value;
        }
      },
    },
    peiInfo: {
      deep: true,
      immediate: true,
      handler(value) {
        if (!this.contractId && value) {
          this.model = value;
        }
      },
    },
    model: {
      deep: true,
      immediate: true,
      handler(value) {
        this.$emit('input', value);
      },
    },
    disciplineTypeId(newValue) {
      if (newValue === disciplineTypes.TerapiaEntrenamientoAuditivo) {
        this.getSubDisciplines();
      }
    },
    subDisciplineTypeId() {
      this.getSubDisciplines();
    },
    subDisciplinesOptions(newValue) {
      if (newValue.length) {
        this.model.subDiscipline = newValue.find(
          (x) => x.id === this.subDisciplineTypeId
        );
      }
    },
    showExtendedSchoolYearService(newValue) {
      if (newValue) {
        this.model.extendedAcademicYearFlag = newValue;
      }
    },
    isEvaluationServiceType(newValue) {
      if (newValue) {
        this.panelStyle.bg = 'bg-secondary-42';
        this.panelStyle.icon = 'fas fa-check-circle color-green';
        this.panelStyle.border = 'border-color--secondary-43';
      }
    },
  },
  props: {
    contractId: {
      type: Number,
      default: () => null,
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    serviceDisciplineName: {
      type: String,
      default: () => '',
    },
    serviceInfo: {
      type: Object,
      default: () => {},
    },
    peiInfo: {
      type: Object,
      default: () => {},
    },
    compensatoryServiceCount: {
      type: Number,
      default: () => null,
    },
    isTherapyServiceType: {
      type: Boolean,
      default: () => false,
    },
    isAssistanceServiceType: {
      type: Boolean,
      default: () => false,
    },
    isEvaluationServiceType: {
      type: Boolean,
      default: () => false,
    },
    serviceInfoMatchWithPei: {
      type: Boolean,
      default: () => false,
    },
    frequencies: {
      type: Array,
      default: () => [],
    },
    durations: {
      type: Array,
      default: () => [],
    },
    modalities: {
      type: Array,
      default: () => [],
    },
    disciplineTypeId: {
      type: Number,
      default: () => 0,
    },
    subDisciplineTypeId: {
      type: Number,
      default: () => 0,
    },
    hasInvalidService: {
      type: Boolean,
      default: () => false,
    },
    amendmentContract: {
      type: Object,
      default: () => ({}),
    },
    isValidCost: {
      type: Boolean,
      default: () => true,
    },
  },
  mounted() {
    if (this.showSubDiscipline) {
      this.getSubDisciplines();
    }
  },
  data: () => ({
    model: {
      frequency: null,
      duration: null,
      modality: null,
      subDiscipline: null,
      extendedAcademicYearFlag: null,
    },
    subDisciplinesOptions: [],
  }),
  computed: {
    avaliableFrequencies() {
      var exclude = [];
      if (
        this.model &&
        this.model.subDiscipline &&
        this.model.subDiscipline.id != subDisciplineTypes.Berard
      ) {
        exclude.push(frequencyType.DosVecesAlDiaPo10DiasCada10Semanas);
      }

      return this.frequencies.filter((x) => !exclude.includes(x.id));
    },
    panelStyle() {
      return {
        icon:
          this.isTherapyServiceType || this.isAssistanceServiceType
            ? this.serviceInfoMatchWithPei
              ? 'fas fa-check-circle color-green'
              : 'fas fa-clock color-orange'
            : 'fas fa-check-circle color-green',
        bg:
          this.isTherapyServiceType || this.isAssistanceServiceType
            ? this.serviceInfoMatchWithPei
              ? 'bg-secondary-42'
              : 'bg-secondary-44'
            : 'bg-secondary-44',
        border:
          this.isTherapyServiceType || this.isAssistanceServiceType
            ? this.serviceInfoMatchWithPei
              ? 'border-color--secondary-43'
              : 'border-color--secondary-44'
            : 'border-color--secondary-43',
      };
    },
    serviceMessage() {
      if (this.isTherapyServiceType) {
        if (!this.peiInfo) {
          return 'El servicio no se encuentra definido en el PEI o PS del estudiante. Favor subir la minuta.';
        } else {
          if (!this.serviceInfoMatchWithPei) {
            return 'El servicio no coincide con los datos definidos en el PEI o PS del estudiante. Favor modificar la información o subir la minuta.';
          }
        }
      }

      if (this.isAssistanceServiceType && this.hasInvalidService) {
        return 'El servicio no se encuentra definido en el PEI o PS del estudiante. Favor subir la minuta.';
      }
      return 'Servicio indicado valida con PEI electrónico vigente.';
    },
    frequencyName() {
      return this.serviceInfo?.frequency?.name;
    },
    durationName() {
      return this.serviceInfo?.duration?.name;
    },
    modalityName() {
      return this.serviceInfo?.modality?.name;
    },
    subDiscipline() {
      return this.serviceInfo?.subDiscipline?.name;
    },
    showSubDiscipline() {
      return (
        this.disciplineTypeId === disciplineTypes.TerapiaEntrenamientoAuditivo
      );
    },
    showExtendedSchoolYearService() {
      const result = this.amendmentContract.selectedReasons.filter(
        (x) => x.id == rpContractAmendmentReasons.AEE
      );
      return result.length > 0;
    },
  },
  methods: {
    async getSubDisciplines() {
      const { data } = await _getSubDisciplines(this.disciplineTypeId);
      this.subDisciplinesOptions = data;
    },
  },
};
</script>
